var _rect, _path, _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_24x24-Key-Circle",
    "data-name": "24x24-Key-Circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Frame24",
    width: 24,
    height: 24,
    fill: "#5a7087",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "baggage-storage",
    d: "M1032.375,508.884a.227.227,0,0,0-.305,0l-1.759,1.76a.342.342,0,0,0,0,.46l.154.154a1.621,1.621,0,0,1-2.291,2.294l-.153-.153a.339.339,0,0,0-.457,0l-.764.763a.228.228,0,0,0,0,.306l.153.153.08.081h0a1.624,1.624,0,0,1,0,2.293,1.661,1.661,0,0,1-2.294,0l-.152-.153a.227.227,0,0,0-.305,0l-.229.229a1.66,1.66,0,0,1-2.29,0,1.686,1.686,0,0,1-.078-2.371l8.021-8.03a.226.226,0,0,0,0-.305,5.088,5.088,0,0,1,2.6-6.423,4.949,4.949,0,0,1,6.492,2.523c.016.035.032.074.049.112h0a4.87,4.87,0,0,1-2.572,6.386,5.286,5.286,0,0,1-3.894-.077Zm3.517-5.961a2.166,2.166,0,0,0-3.054,0h0a2.157,2.157,0,1,0,3.051,0Z",
    transform: "translate(-1018.234 -496.531)",
    fill: "#5a7087"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    media: "screen"
  }, "path{vector-effect:non-scaling-stroke}")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.10ab5cac2432ddd3a742bf6719b5410d.svg";
export { ForwardRef as ReactComponent };